export default [
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "description": "Mieux comprendre un texte et mieux écrire en décomposant intuitivement une phrase en groupes de mots.",
    "difficulte": "Résolution d’erreurs d’interprétation et de construction induites par la difficulté à décomposer une suite de mots en groupes de mots bien constitués."
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "description": "Mieux comprendre un texte et mieux écrire en hiérarchisant les éléments d’une phrase.",
    "difficulte": "Résolution d’erreurs d’interprétation et de construction induites par la mauvaise identification des dépendances et des relations entre groupes de mots à l’intérieur d’une phrase."
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "description": "Approfondir la maîtrise de la langue en travaillant sur les ambiguïtés de structure.",
    "difficulte": "Travailler l'ambiguïté structurelle (ambiguïté de rattachement des groupes prépositionnels (_je vois la fille avec un télescope_), de découpage des relatives (_la fille du capitaine qui est à la fenêtre_), etc.) permet de comprendre que le sens d’une phrase est intimement lié à sa structure, que les locuteurs construisent le sens d’une phrase en se basant sur leur intuition propre du caractère hiérarchique des mots dans une phrase."
  }
 ];